import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, PackageIcon, ClockIcon } from 'lucide-react';
export function TerritoriesSection() {
  const features = [{
    icon: GlobeIcon,
    title: 'Regional Coverage',
    description: 'Serving EU, Middle East (UAE), and East Asia markets'
  }, {
    icon: PackageIcon,
    title: 'Flexible MOQs',
    description: 'Standard minimum order quantities with wholesale pricing'
  }, {
    icon: ClockIcon,
    title: 'Quick Onboarding',
    description: 'Reseller setup completed within 48 hours'
  }];
  return <section className="py-20 px-6 relative overflow-hidden bg-white" data-id="element-257">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-258" />
      {/* Network Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-259" />
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-261">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-262">
            Territories & MOQs
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-263">
            Standard MOQs with competitive wholesale pricing. Reseller
            onboarding completed in 48 hours with dedicated support throughout
            the process.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-264">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-100" data-id="element-265">
              <div className="w-16 h-16 bg-gradient-to-br from-[#3B82F6]/10 to-[#10B981]/10 rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-266">
                <feature.icon className="w-8 h-8 text-[#3B82F6]" data-id="element-267" />
              </div>
              <h3 className="text-lg font-bold text-[#0B1220] mb-2" data-id="element-268">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-269">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}